module.exports = __webpack_public_path__ + "media/app_search/Invitation/assets/icon-google-auth-185ccfc36e8d6303f93458207c800dda.svg";